import { gql } from 'graphql-request';

const deleteUserReview = gql`
  mutation DeleteUserReview($audiobookId: ID!) {
    deleteUserReview(audiobookId: $audiobookId) {
      errors
    }
  }
`;

const likeUserReview = gql`
  mutation LikeUserReview($userReviewId: ID!) {
    likeUserReview(userReviewId: $userReviewId) {
      errors
    }
  }
`;

const postUserReview = gql`
  mutation postUserReview($audiobookId: ID!, $rating: Int, $review: String) {
    postUserReview(audiobookId: $audiobookId, rating: $rating, review: $review) {
      userPersonFollow {
        id
        person {
          slug
        }
      }
    }
  }
`;

const reportUserReview = gql`
  mutation reportUserReview($userReviewId: ID!) {
    reportUserReview(userReviewId: $userReviewId) {
      success
    }
  }
`;

const unlikeUserReview = gql`
  mutation UnlikeUserReview($userReviewId: ID!) {
    unlikeUserReview(userReviewId: $userReviewId) {
      errors
    }
  }
`;

export const userReviewMutations = {
  deleteUserReview,
  likeUserReview,
  postUserReview,
  reportUserReview,
  unlikeUserReview,
};
